<template>
    <input v-model="captcha_token" name="captcha_token" type="hidden">
</template>

<script>
import {useReCaptcha} from 'vue-recaptcha-v3';
import {onMounted, ref} from "vue";

export default {
    setup() {
        const captcha_token = ref()
        const {executeRecaptcha, recaptchaLoaded} = useReCaptcha()
        onMounted(async () => {
            // await recaptchaLoaded()
            // captcha_token.value = await executeRecaptcha('contactUs')
            captcha_token.value = 'x'
        })
        return {captcha_token}
    }
}
</script>
